import { useIthacaInitialization } from '@dtx-company/inter-app/src/hooks/auth/useIthacaInitialization'
import { useListenForAuthChanges } from '@dtx-company/inter-app/src/hooks/auth/useListenForAuthChanges'

export function useInitializeAuthServices(): void {
  useListenForAuthChanges()
  useIthacaInitialization()
}
